const countries = [
  {
    name: 'United Kingdom',
    code: '+44',
    iso: 'GB',
    iso3: 'GBR'
  },
  {
    name: 'France',
    code: '+33',
    iso: 'FR',
    iso3: 'FRA'
  },
  {
    name: 'Belgium',
    code: '+32',
    iso: 'BE',
    iso3: 'BEL'
  },
  {
    name: 'Netherlands',
    code: '+31',
    iso: 'NL',
    iso3: 'NLD'
  },
  {
    name: 'United States',
    code: '+1',
    iso: 'US',
    iso3: 'USA'
  },
  {
    name: 'Afghanistan',
    code: '+93',
    iso: 'AF',
    iso3: 'AFG'
  },
  {
    name: 'Aland Islands',
    code: '+358',
    iso: 'AX',
    iso3: 'ALA'
  },
  {
    name: 'Albania',
    code: '+355',
    iso: 'AL',
    iso3: 'ALB'
  },
  {
    name: 'Algeria',
    code: '+213',
    iso: 'DZ',
    iso3: 'DZA'
  },
  {
    name: 'AmericanSamoa',
    code: '+1684',
    iso: 'AS',
    iso3: 'ASM'
  },
  {
    name: 'Andorra',
    code: '+376',
    iso: 'AD',
    iso3: 'AND'
  },
  {
    name: 'Angola',
    code: '+244',
    iso: 'AO',
    iso3: 'AGO'
  },
  {
    name: 'Anguilla',
    code: '+1264',
    iso: 'AI',
    iso3: 'AIA'
  },
  {
    name: 'Antarctica',
    code: '+672',
    iso: 'AQ',
    iso3: 'ATA'
  },
  {
    name: 'Antigua and Barbuda',
    code: '+1268',
    iso: 'AG',
    iso3: 'ATG'
  },
  {
    name: 'Argentina',
    code: '+54',
    iso: 'AR',
    iso3: 'ARG'
  },
  {
    name: 'Armenia',
    code: '+374',
    iso: 'AM',
    iso3: 'ARM'
  },
  {
    name: 'Aruba',
    code: '+297',
    iso: 'AW',
    iso3: 'ABW'
  },
  {
    name: 'Australia',
    code: '+61',
    iso: 'AU',
    iso3: 'AUS'
  },
  {
    name: 'Austria',
    code: '+43',
    iso: 'AT',
    iso3: 'AUT'
  },
  {
    name: 'Azerbaijan',
    code: '+994',
    iso: 'AZ',
    iso3: 'AZE'
  },
  {
    name: 'Bahamas',
    code: '+1242',
    iso: 'BS',
    iso3: 'BHS'
  },
  {
    name: 'Bahrain',
    code: '+973',
    iso: 'BH',
    iso3: 'BHR'
  },
  {
    name: 'Bangladesh',
    code: '+880',
    iso: 'BD',
    iso3: 'BGD'
  },
  {
    name: 'Barbados',
    code: '+1246',
    iso: 'BB',
    iso3: 'BRB'
  },
  {
    name: 'Belarus',
    code: '+375',
    iso: 'BY',
    iso3: 'BLR'
  },
  {
    name: 'Belize',
    code: '+501',
    iso: 'BZ',
    iso3: 'BLZ'
  },
  {
    name: 'Benin',
    code: '+229',
    iso: 'BJ',
    iso3: 'BEN'
  },
  {
    name: 'Bermuda',
    code: '+1441',
    iso: 'BM',
    iso3: 'BMU'
  },
  {
    name: 'Bhutan',
    code: '+975',
    iso: 'BT',
    iso3: 'BTN'
  },
  {
    name: 'Bolivia, Plurinational State of',
    code: '+591',
    iso: 'BO',
    iso3: 'BOL'
  },
  {
    name: 'Bosnia and Herzegovina',
    code: '+387',
    iso: 'BA',
    iso3: 'BIH'
  },
  {
    name: 'Botswana',
    code: '+267',
    iso: 'BW',
    iso3: 'BWA'
  },
  {
    name: 'Brazil',
    code: '+55',
    iso: 'BR',
    iso3: 'BRA'
  },
  {
    name: 'British Indian Ocean Territory',
    code: '+246',
    iso: 'IO',
    iso3: 'IOT'
  },
  {
    name: 'Brunei Darussalam',
    code: '+673',
    iso: 'BN',
    iso3: 'BRN'
  },
  {
    name: 'Bulgaria',
    code: '+359',
    iso: 'BG',
    iso3: 'BGR'
  },
  {
    name: 'Burkina Faso',
    code: '+226',
    iso: 'BF',
    iso3: 'BFA'
  },
  {
    name: 'Burundi',
    code: '+257',
    iso: 'BI',
    iso3: 'BDI'
  },
  {
    name: 'Cambodia',
    code: '+855',
    iso: 'KH',
    iso3: 'KHM'
  },
  {
    name: 'Cameroon',
    code: '+237',
    iso: 'CM',
    iso3: 'CMR'
  },
  {
    name: 'Canada',
    code: '+1',
    iso: 'CA',
    iso3: 'CAN'
  },
  {
    name: 'Cape Verde',
    code: '+238',
    iso: 'CV',
    iso3: 'CPV'
  },
  {
    name: 'Cayman Islands',
    code: '+345',
    iso: 'KY',
    iso3: 'CYM'
  },
  {
    name: 'Central African Republic',
    code: '+236',
    iso: 'CF',
    iso3: 'CAF'
  },
  {
    name: 'Chad',
    code: '+235',
    iso: 'TD',
    iso3: 'TCD'
  },
  {
    name: 'Chile',
    code: '+56',
    iso: 'CL',
    iso3: 'CHL'
  },
  {
    name: 'China',
    code: '+86',
    iso: 'CN',
    iso3: 'CHN'
  },
  {
    name: 'Christmas Island',
    code: '+61',
    iso: 'CX',
    iso3: 'CXR'
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: '+61',
    iso: 'CC',
    iso3: 'CCK'
  },
  {
    name: 'Colombia',
    code: '+57',
    iso: 'CO',
    iso3: 'COL'
  },
  {
    name: 'Comoros',
    code: '+269',
    iso: 'KM',
    iso3: 'COM'
  },
  {
    name: 'Congo',
    code: '+242',
    iso: 'CG',
    iso3: 'COG'
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    code: '+243',
    iso: 'CD',
    iso3: 'COD'
  },
  {
    name: 'Cook Islands',
    code: '+682',
    iso: 'CK',
    iso3: 'COK'
  },
  {
    name: 'Costa Rica',
    code: '+506',
    iso: 'CR',
    iso3: 'CRI'
  },
  {
    name: "Cote d'Ivoire",
    code: '+225',
    iso: 'CI',
    iso3: 'CIV'
  },
  {
    name: 'Croatia',
    code: '+385',
    iso: 'HR',
    iso3: 'HRV'
  },
  {
    name: 'Cuba',
    code: '+53',
    iso: 'CU',
    iso3: 'CUB'
  },
  {
    name: 'Cyprus',
    code: '+357',
    iso: 'CY',
    iso3: 'CYP'
  },
  {
    name: 'Czech Republic',
    code: '+420',
    iso: 'CZ',
    iso3: 'CZE'
  },
  {
    name: 'Denmark',
    code: '+45',
    iso: 'DK',
    iso3: 'DNK'
  },
  {
    name: 'Djibouti',
    code: '+253',
    iso: 'DJ',
    iso3: 'DJI'
  },
  {
    name: 'Dominica',
    code: '+1767',
    iso: 'DM',
    iso3: 'DMA'
  },
  {
    name: 'Dominican Republic',
    code: '+1849',
    iso: 'DO',
    iso3: 'DOM'
  },
  {
    name: 'Ecuador',
    code: '+593',
    iso: 'EC',
    iso3: 'ECU'
  },
  {
    name: 'Egypt',
    code: '+20',
    iso: 'EG',
    iso3: 'EGY'
  },
  {
    name: 'El Salvador',
    code: '+503',
    iso: 'SV',
    iso3: 'SLV'
  },
  {
    name: 'Equatorial Guinea',
    code: '+240',
    iso: 'GQ',
    iso3: 'GNQ'
  },
  {
    name: 'Eritrea',
    code: '+291',
    iso: 'ER',
    iso3: 'ERI'
  },
  {
    name: 'Estonia',
    code: '+372',
    iso: 'EE',
    iso3: 'EST'
  },
  {
    name: 'Ethiopia',
    code: '+251',
    iso: 'ET',
    iso3: 'ETH'
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: '+500',
    iso: 'FK',
    iso3: 'FLK'
  },
  {
    name: 'Faroe Islands',
    code: '+298',
    iso: 'FO',
    iso3: 'FRO'
  },
  {
    name: 'Fiji',
    code: '+679',
    iso: 'FJ',
    iso3: 'FJI'
  },
  {
    name: 'Finland',
    code: '+358',
    iso: 'FI',
    iso3: 'FIN'
  },
  {
    name: 'French Guiana',
    code: '+594',
    iso: 'GF',
    iso3: 'GUF'
  },
  {
    name: 'French Polynesia',
    code: '+689',
    iso: 'PF',
    iso3: 'PYF'
  },
  {
    name: 'Gabon',
    code: '+241',
    iso: 'GA',
    iso3: 'GAB'
  },
  {
    name: 'Gambia',
    code: '+220',
    iso: 'GM',
    iso3: 'GMB'
  },
  {
    name: 'Georgia',
    code: '+995',
    iso: 'GE',
    iso3: 'GEO'
  },
  {
    name: 'Germany',
    code: '+49',
    iso: 'DE',
    iso3: 'DEU'
  },
  {
    name: 'Ghana',
    code: '+233',
    iso: 'GH',
    iso3: 'GHA'
  },
  {
    name: 'Gibraltar',
    code: '+350',
    iso: 'GI',
    iso3: 'GIB'
  },
  {
    name: 'Greece',
    code: '+30',
    iso: 'GR',
    iso3: 'GRC'
  },
  {
    name: 'Greenland',
    code: '+299',
    iso: 'GL',
    iso3: 'GRL'
  },
  {
    name: 'Grenada',
    code: '+1473',
    iso: 'GD',
    iso3: 'GRD'
  },
  {
    name: 'Guadeloupe',
    code: '+590',
    iso: 'GP',
    iso3: 'GLP'
  },
  {
    name: 'Guam',
    code: '+1671',
    iso: 'GU',
    iso3: 'GUM'
  },
  {
    name: 'Guatemala',
    code: '+502',
    iso: 'GT',
    iso3: 'GTM'
  },
  {
    name: 'Guernsey',
    code: '+44',
    iso: 'GG',
    iso3: 'GGY'
  },
  {
    name: 'Guinea',
    code: '+224',
    iso: 'GN',
    iso3: 'GIN'
  },
  {
    name: 'Guinea-Bissau',
    code: '+245',
    iso: 'GW',
    iso3: 'GNB'
  },
  {
    name: 'Guyana',
    code: '+592',
    iso: 'GY',
    iso3: 'GUY'
  },
  {
    name: 'Haiti',
    code: '+509',
    iso: 'HT',
    iso3: 'HTI'
  },
  {
    name: 'Holy See (Vatican City State)',
    code: '+379',
    iso: 'VA',
    iso3: 'VAT'
  },
  {
    name: 'Honduras',
    code: '+504',
    iso: 'HN',
    iso3: 'HND'
  },
  {
    name: 'Hong Kong',
    code: '+852',
    iso: 'HK',
    iso3: 'HKG'
  },
  {
    name: 'Hungary',
    code: '+36',
    iso: 'HU',
    iso3: 'HUN'
  },
  {
    name: 'Iceland',
    code: '+354',
    iso: 'IS',
    iso3: 'ISL'
  },
  {
    name: 'India',
    code: '+91',
    iso: 'IN',
    iso3: 'IND'
  },
  {
    name: 'Indonesia',
    code: '+62',
    iso: 'ID',
    iso3: 'IDN'
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    code: '+98',
    iso: 'IR',
    iso3: 'IRN'
  },
  {
    name: 'Iraq',
    code: '+964',
    iso: 'IQ',
    iso3: 'IRQ'
  },
  {
    name: 'Ireland',
    code: '+353',
    iso: 'IE',
    iso3: 'IRL'
  },
  {
    name: 'Isle of Man',
    code: '+44',
    iso: 'IM',
    iso3: 'IMN'
  },
  {
    name: 'Israel',
    code: '+972',
    iso: 'IL',
    iso3: 'ISR'
  },
  {
    name: 'Italy',
    code: '+39',
    iso: 'IT',
    iso3: 'ITA'
  },
  {
    name: 'Jamaica',
    code: '+1876',
    iso: 'JM',
    iso3: 'JAM'
  },
  {
    name: 'Japan',
    code: '+81',
    iso: 'JP',
    iso3: 'JPN'
  },
  {
    name: 'Jersey',
    code: '+44',
    iso: 'JE',
    iso3: 'JEY'
  },
  {
    name: 'Jordan',
    code: '+962',
    iso: 'JO',
    iso3: 'JOR'
  },
  {
    name: 'Kazakhstan',
    code: '+77',
    iso: 'KZ',
    iso3: 'KAZ'
  },
  {
    name: 'Kenya',
    code: '+254',
    iso: 'KE',
    iso3: 'KEN'
  },
  {
    name: 'Kiribati',
    code: '+686',
    iso: 'KI',
    iso3: 'KIR'
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    code: '+850',
    iso: 'KP',
    iso3: 'PRK'
  },
  {
    name: 'Korea, Republic of South Korea',
    code: '+82',
    iso: 'KR',
    iso3: 'KOR'
  },
  {
    name: 'Kuwait',
    code: '+965',
    iso: 'KW',
    iso3: 'KWT'
  },
  {
    name: 'Kyrgyzstan',
    code: '+996',
    iso: 'KG',
    iso3: 'KGZ'
  },
  {
    name: 'Laos',
    code: '+856',
    iso: 'LA',
    iso3: 'LAO'
  },
  {
    name: 'Latvia',
    code: '+371',
    iso: 'LV',
    iso3: 'LVA'
  },
  {
    name: 'Lebanon',
    code: '+961',
    iso: 'LB',
    iso3: 'LBN'
  },
  {
    name: 'Lesotho',
    code: '+266',
    iso: 'LS',
    iso3: 'LSO'
  },
  {
    name: 'Liberia',
    code: '+231',
    iso: 'LR',
    iso3: 'LBR'
  },
  {
    name: 'Libyan Arab Jamahiriya',
    code: '+218',
    iso: 'LY',
    iso3: 'LBY'
  },
  {
    name: 'Liechtenstein',
    code: '+423',
    iso: 'LI',
    iso3: 'LIE'
  },
  {
    name: 'Lithuania',
    code: '+370',
    iso: 'LT',
    iso3: 'LTU'
  },
  {
    name: 'Luxembourg',
    code: '+352',
    iso: 'LU',
    iso3: 'LUX'
  },
  {
    name: 'Macao',
    code: '+853',
    iso: 'MO',
    iso3: 'MAC'
  },
  {
    name: 'Macedonia',
    code: '+389',
    iso: 'MK',
    iso3: 'MKD'
  },
  {
    name: 'Madagascar',
    code: '+261',
    iso: 'MG',
    iso3: 'MDG'
  },
  {
    name: 'Malawi',
    code: '+265',
    iso: 'MW',
    iso3: 'MWI'
  },
  {
    name: 'Malaysia',
    code: '+60',
    iso: 'MY',
    iso3: 'MYS'
  },
  {
    name: 'Maldives',
    code: '+960',
    iso: 'MV',
    iso3: 'MDV'
  },
  {
    name: 'Mali',
    code: '+223',
    iso: 'ML',
    iso3: 'MLI'
  },
  {
    name: 'Malta',
    code: '+356',
    iso: 'MT',
    iso3: 'MLT'
  },
  {
    name: 'Marshall Islands',
    code: '+692',
    iso: 'MH',
    iso3: 'MHL'
  },
  {
    name: 'Martinique',
    code: '+596',
    iso: 'MQ',
    iso3: 'MTQ'
  },
  {
    name: 'Mauritania',
    code: '+222',
    iso: 'MR',
    iso3: 'MRT'
  },
  {
    name: 'Mauritius',
    code: '+230',
    iso: 'MU',
    iso3: 'MUS'
  },
  {
    name: 'Mayotte',
    code: '+262',
    iso: 'YT',
    iso3: 'MYT'
  },
  {
    name: 'Mexico',
    code: '+52',
    iso: 'MX',
    iso3: 'MEX'
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    code: '+691',
    iso: 'FM',
    iso3: 'FSM'
  },
  {
    name: 'Moldova',
    code: '+373',
    iso: 'MD',
    iso3: 'MDA'
  },
  {
    name: 'Monaco',
    code: '+377',
    iso: 'MC',
    iso3: 'MCO'
  },
  {
    name: 'Mongolia',
    code: '+976',
    iso: 'MN',
    iso3: 'MNG'
  },
  {
    name: 'Montenegro',
    code: '+382',
    iso: 'ME',
    iso3: 'MNE'
  },
  {
    name: 'Montserrat',
    code: '+1664',
    iso: 'MS',
    iso3: 'MSR'
  },
  {
    name: 'Morocco',
    code: '+212',
    iso: 'MA',
    iso3: 'MAR'
  },
  {
    name: 'Mozambique',
    code: '+258',
    iso: 'MZ',
    iso3: 'MOZ'
  },
  {
    name: 'Myanmar',
    code: '+95',
    iso: 'MM',
    iso3: 'MMR'
  },
  {
    name: 'Namibia',
    code: '+264',
    iso: 'NA',
    iso3: 'NAM'
  },
  {
    name: 'Nauru',
    code: '+674',
    iso: 'NR',
    iso3: 'NRU'
  },
  {
    name: 'Nepal',
    code: '+977',
    iso: 'NP',
    iso3: 'NPL'
  },
  {
    name: 'Netherlands Antilles',
    code: '+599',
    iso: 'AN',
    iso3: 'ANT'
  },
  {
    name: 'New Caledonia',
    code: '+687',
    iso: 'NC',
    iso3: 'NCL'
  },
  {
    name: 'New Zealand',
    code: '+64',
    iso: 'NZ',
    iso3: 'NZL'
  },
  {
    name: 'Nicaragua',
    code: '+505',
    iso: 'NI',
    iso3: 'NIC'
  },
  {
    name: 'Niger',
    code: '+227',
    iso: 'NE',
    iso3: 'NER'
  },
  {
    name: 'Nigeria',
    code: '+234',
    iso: 'NG',
    iso3: 'NGA'
  },
  {
    name: 'Niue',
    code: '+683',
    iso: 'NU',
    iso3: 'NIU'
  },
  {
    name: 'Norfolk Island',
    code: '+672',
    iso: 'NF',
    iso3: 'NFK'
  },
  {
    name: 'Northern Mariana Islands',
    code: '+1670',
    iso: 'MP',
    iso3: 'MNP'
  },
  {
    name: 'Norway',
    code: '+47',
    iso: 'NO',
    iso3: 'NOR'
  },
  {
    name: 'Oman',
    code: '+968',
    iso: 'OM',
    iso3: 'OMN'
  },
  {
    name: 'Pakistan',
    code: '+92',
    iso: 'PK',
    iso3: 'PAK'
  },
  {
    name: 'Palau',
    code: '+680',
    iso: 'PW',
    iso3: 'PLW'
  },
  {
    name: 'Palestinian Territory, Occupied',
    code: '+970',
    iso: 'PS',
    iso3: 'PSE'
  },
  {
    name: 'Panama',
    code: '+507',
    iso: 'PA',
    iso3: 'PAN'
  },
  {
    name: 'Papua New Guinea',
    code: '+675',
    iso: 'PG',
    iso3: 'PNG'
  },
  {
    name: 'Paraguay',
    code: '+595',
    iso: 'PY',
    iso3: 'PRY'
  },
  {
    name: 'Peru',
    code: '+51',
    iso: 'PE',
    iso3: 'PER'
  },
  {
    name: 'Philippines',
    code: '+63',
    iso: 'PH',
    iso3: 'PHL'
  },
  {
    name: 'Pitcairn',
    code: '+872',
    iso: 'PN',
    iso3: 'PCN'
  },
  {
    name: 'Poland',
    code: '+48',
    iso: 'PL',
    iso3: 'POL'
  },
  {
    name: 'Portugal',
    code: '+351',
    iso: 'PT',
    iso3: 'PRT'
  },
  {
    name: 'Puerto Rico',
    code: '+1939',
    iso: 'PR',
    iso3: 'PRI'
  },
  {
    name: 'Qatar',
    code: '+974',
    iso: 'QA',
    iso3: 'QAT'
  },
  {
    name: 'Romania',
    code: '+40',
    iso: 'RO',
    iso3: 'ROU'
  },
  {
    name: 'Russia',
    code: '+7',
    iso: 'RU',
    iso3: 'RUS'
  },
  {
    name: 'Rwanda',
    code: '+250',
    iso: 'RW',
    iso3: 'RWA'
  },
  {
    name: 'Reunion',
    code: '+262',
    iso: 'RE',
    iso3: 'REU'
  },
  {
    name: 'Saint Barthelemy',
    code: '+590',
    iso: 'BL',
    iso3: 'BLM'
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    code: '+290',
    iso: 'SH',
    iso3: 'SHN'
  },
  {
    name: 'Saint Kitts and Nevis',
    code: '+1869',
    iso: 'KN',
    iso3: 'KNA'
  },
  {
    name: 'Saint Lucia',
    code: '+1758',
    iso: 'LC',
    iso3: 'LCA'
  },
  {
    name: 'Saint Martin',
    code: '+590',
    iso: 'MF',
    iso3: 'MAF'
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: '+508',
    iso: 'PM',
    iso3: 'SPM'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: '+1784',
    iso: 'VC',
    iso3: 'VCT'
  },
  {
    name: 'Samoa',
    code: '+685',
    iso: 'WS',
    iso3: 'WSM'
  },
  {
    name: 'San Marino',
    code: '+378',
    iso: 'SM',
    iso3: 'SMR'
  },
  {
    name: 'Sao Tome and Principe',
    code: '+239',
    iso: 'ST',
    iso3: 'STP'
  },
  {
    name: 'Saudi Arabia',
    code: '+966',
    iso: 'SA',
    iso3: 'SAU'
  },
  {
    name: 'Senegal',
    code: '+221',
    iso: 'SN',
    iso3: 'SEN'
  },
  {
    name: 'Serbia',
    code: '+381',
    iso: 'RS',
    iso3: 'SRB'
  },
  {
    name: 'Seychelles',
    code: '+248',
    iso: 'SC',
    iso3: 'SYC'
  },
  {
    name: 'Sierra Leone',
    code: '+232',
    iso: 'SL',
    iso3: 'SLE'
  },
  {
    name: 'Singapore',
    code: '+65',
    iso: 'SG',
    iso3: 'SGP'
  },
  {
    name: 'Slovakia',
    code: '+421',
    iso: 'SK',
    iso3: 'SVK'
  },
  {
    name: 'Slovenia',
    code: '+386',
    iso: 'SI',
    iso3: 'SVN'
  },
  {
    name: 'Solomon Islands',
    code: '+677',
    iso: 'SB',
    iso3: 'SLB'
  },
  {
    name: 'Somalia',
    code: '+252',
    iso: 'SO',
    iso3: 'SOM'
  },
  {
    name: 'South Africa',
    code: '+27',
    iso: 'ZA',
    iso3: 'ZAF'
  },
  {
    name: 'South Sudan',
    code: '+211',
    iso: 'SS',
    iso3: 'SSD'
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: '+500',
    iso: 'GS',
    iso3: 'SGS'
  },
  {
    name: 'Spain',
    code: '+34',
    iso: 'ES',
    iso3: 'ESP'
  },
  {
    name: 'Sri Lanka',
    code: '+94',
    iso: 'LK',
    iso3: 'LKA'
  },
  {
    name: 'Sudan',
    code: '+249',
    iso: 'SD',
    iso3: 'SDN'
  },
  {
    name: 'Suriname',
    code: '+597',
    iso: 'SR',
    iso3: 'SUR'
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: '+47',
    iso: 'SJ',
    iso3: 'SJM'
  },
  {
    name: 'Swaziland',
    code: '+268',
    iso: 'SZ',
    iso3: 'SWZ'
  },
  {
    name: 'Sweden',
    code: '+46',
    iso: 'SE',
    iso3: 'SWE'
  },
  {
    name: 'Switzerland',
    code: '+41',
    iso: 'CH',
    iso3: 'CHE'
  },
  {
    name: 'Syrian Arab Republic',
    code: '+963',
    iso: 'SY',
    iso3: 'SYR'
  },
  {
    name: 'Taiwan',
    code: '+886',
    iso: 'TW',
    iso3: 'TWN'
  },
  {
    name: 'Tajikistan',
    code: '+992',
    iso: 'TJ',
    iso3: 'TJK'
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    code: '+255',
    iso: 'TZ',
    iso3: 'TZA'
  },
  {
    name: 'Thailand',
    code: '+66',
    iso: 'TH',
    iso3: 'THA'
  },
  {
    name: 'Timor-Leste',
    code: '+670',
    iso: 'TL',
    iso3: 'TLS'
  },
  {
    name: 'Togo',
    code: '+228',
    iso: 'TG',
    iso3: 'TGO'
  },
  {
    name: 'Tokelau',
    code: '+690',
    iso: 'TK',
    iso3: 'TKL'
  },
  {
    name: 'Tonga',
    code: '+676',
    iso: 'TO',
    iso3: 'TON'
  },
  {
    name: 'Trinidad and Tobago',
    code: '+1868',
    iso: 'TT',
    iso3: 'TTO'
  },
  {
    name: 'Tunisia',
    code: '+216',
    iso: 'TN',
    iso3: 'TUN'
  },
  {
    name: 'Turkey',
    code: '+90',
    iso: 'TR',
    iso3: 'TUR'
  },
  {
    name: 'Turkmenistan',
    code: '+993',
    iso: 'TM',
    iso3: 'TKM'
  },
  {
    name: 'Turks and Caicos Islands',
    code: '+1649',
    iso: 'TC',
    iso3: 'TCA'
  },
  {
    name: 'Tuvalu',
    code: '+688',
    iso: 'TV',
    iso3: 'TUV'
  },
  {
    name: 'Uganda',
    code: '+256',
    iso: 'UG',
    iso3: 'UGA'
  },
  {
    name: 'Ukraine',
    code: '+380',
    iso: 'UA',
    iso3: 'UKR'
  },
  {
    name: 'United Arab Emirates',
    code: '+971',
    iso: 'AE',
    iso3: 'ARE'
  },
  {
    name: 'Uruguay',
    code: '+598',
    iso: 'UY',
    iso3: 'URY'
  },
  {
    name: 'Uzbekistan',
    code: '+998',
    iso: 'UZ',
    iso3: 'UZB'
  },
  {
    name: 'Vanuatu',
    code: '+678',
    iso: 'VU',
    iso3: 'VUT'
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    code: '+58',
    iso: 'VE',
    iso3: 'VEN'
  },
  {
    name: 'Vietnam',
    code: '+84',
    iso: 'VN',
    iso3: 'VNM'
  },
  {
    name: 'Virgin Islands, British',
    code: '+1284',
    iso: 'VG',
    iso3: 'VGB'
  },
  {
    name: 'Virgin Islands, U.S.',
    code: '+1340',
    iso: 'VI',
    iso3: 'VIR'
  },
  {
    name: 'Wallis and Futuna',
    code: '+681',
    iso: 'WF',
    iso3: 'WLF'
  },
  {
    name: 'Yemen',
    code: '+967',
    iso: 'YE',
    iso3: 'YEM'
  },
  {
    name: 'Zambia',
    code: '+260',
    iso: 'ZM',
    iso3: 'ZMB'
  },
  {
    name: 'Zimbabwe',
    code: '+263',
    iso: 'ZW',
    iso3: 'ZWE'
  }
];

export default countries;
